"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userDetailsConstants = void 0;
const userDetailsConstants = exports.userDetailsConstants = {
  /* Breadcrumb */
  MANAGE_YOUR_TEAM: 'Manage your team',
  BRCM_MINE_SITE: '<MineSiteLabel>',
  /* MINES SITES Tab Constants */
  MINESITES_HEADING: 'Assigned <MineSiteLabelPlural>',
  BUTTON_LABEL: 'Add user to <MineSiteLabelPlural>',
  RM_ACCESS_BUTTON: 'REMOVE ACCESS',
  CANCEL_BUTTON: 'CANCEL',
  POPUP_CONFIRM: 'Are you sure you want to remove Assigned App',
  AUTOSEARC_PLACEHOLDER: 'Select app role',
  ROLE: 'ROLE',
  REMOVE_ACCESS: 'REMOVE ACCESS',
  /* User Activity Tab Constants */
  ACTIVITY_FOR: 'Activity for',
  DATE: 'DATE',
  APPLICATION_NAME: 'APPLICATION NAME',
  STATUS: 'STATUS',
  LOCATION: 'LOCATION',
  IP_ADDRESS: 'IP ADDRESS',
  /* Navigation Page Constants */
  USER_ACTIVITY: "USER'S ACTIVITY",
  MINESITES_LINK: '/minesites',
  USER_ACTIVITY_LINK: '/useractivity'
};